import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18N, I18NContext } from 'commons';

const SkipButton = ({ isShow, onClick, ebTestValue }) => {
  const i18n = useContext(I18NContext);
  return (
    <div className="col-md-5">
      <button
        style={{ display: isShow ? 'block' : 'none' }}
        className="btn btn-secondary btn-block"
        type="button"
        onClick={onClick}
        eb-test={ebTestValue}
        value={i18n['global.dialog.button.cancel']}
      >
        <I18N>global.dialog.button.cancel</I18N>
      </button>
    </div>
  );
};

SkipButton.propTypes = {
  onClick: PropTypes.func,
  ebTestValue: PropTypes.string.isRequired,
  isShow: PropTypes.bool.isRequired,
};

SkipButton.defaultProps = {
  onClick: () => { },
};

export default SkipButton;
